var exports = {
  "kL": "SlowmodeIndicator.module__container___ZHpleV",
  "K2": "SlowmodeIndicator.module__cooldown___ZHpleV",
  "Pf": "SlowmodeIndicator.module__label___ZHpleV",
  "Kk": "SlowmodeIndicator.module__icon___ZHpleV",
};

module.exports = exports;
